import type {PickerVariable} from "./types";

export const matchesQuery = (variable: PickerVariable, query: string) => {
    const needle = query.trim().toLowerCase();

    return !needle || [variable.key, variable.label, variable.scope]
        .some(candidate => candidate.toLowerCase().includes(needle));
};

/** Where the query first occurs in `text`, ignoring case — what a row highlights. */
export const firstMatchRange = (text: string, query: string): [number, number] | null => {
    const needle = query.trim().toLowerCase();
    const at = needle ? text.toLowerCase().indexOf(needle) : -1;

    return at === -1 ? null : [at, at + needle.length];
};
